module.exports = new __parcel__URL__("machines_glfhers_arcade_level_1.6fda782c.png").toString();